var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { createSlice, current } from '@reduxjs/toolkit';
import { omit } from 'lodash';
import { PlatformType } from 'app/views/components/dialogs/publish/platform';
const initialState = {
    selected: PlatformType.Annotely,
    platforms: {
        [PlatformType.Annotely]: { history: [] },
    },
};
export const publishSlice = createSlice({
    name: 'publish',
    initialState,
    reducers: {
        selectPlatform: (state, action) => {
            if (state.selected !== action.payload) {
                state.selected = action.payload;
            }
        },
        setAuthToken: (state, action) => {
            const { platform, token } = action.payload;
            state.platforms[platform] = Object.assign(Object.assign({}, state.platforms[platform]), { auth: token, history: [] });
        },
        setJobState: (state, action) => {
            const _a = action.payload, { platform } = _a, jobState = __rest(_a, ["platform"]);
            const platformState = state.platforms[platform];
            const { job: publishJob } = platformState || {};
            switch (jobState.state) {
                case 'publishing':
                    if (publishJob && (publishJob === null || publishJob === void 0 ? void 0 : publishJob.state) === 'publishing') {
                        return;
                    }
                    break;
                case 'error':
                    if ((publishJob === null || publishJob === void 0 ? void 0 : publishJob.state) !== 'publishing') {
                        return;
                    }
                    break;
                case 'published':
                    if (publishJob) {
                        if (publishJob.state !== 'publishing') {
                            return;
                        }
                        const history = current(platformState.history);
                        state.platforms[platform].history = [omit(jobState, ['state'])].concat(history);
                    }
                    break;
                default:
                    return;
            }
            state.platforms[platform].job = jobState;
        },
    },
});
